import { Wallet } from "lucide-react";
import React, { useEffect } from "react";
import { useBalance } from "../../hooks/useBalance";
import { useLocation } from "react-router-dom";
export const BalanceInfo: React.FC = () => {
  const { balance, loading, refresh } = useBalance();
  const location = useLocation();

  useEffect(() => {
    refresh();
  }, [location.pathname, refresh]);

  return (
    <div className="bg-[#f0f2f5] dark:bg-[#2A2A2A] rounded-xl px-4 py-3 flex items-center justify-between border border-gray-300 dark:border-gray-700 shadow-sm dark:shadow-[0_0_10px_#00000020] transition-colors duration-300">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-gray-200 dark:bg-gray-700 rounded-full">
          <Wallet className="w-5 h-5 text-black dark:text-white" />
        </div>
        <div>
          <p className="text-sm text-gray-500 dark:text-gray-400">Main</p>
          <p className="text-lg font-mono font-semibold text-[#1f1f1f] dark:text-white tracking-wide">
            {loading ? "..." : `${balance?.toFixed(4)}$`}
          </p>
        </div>
      </div>
    </div>
  );
};
